/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ManageAccountComponent } from './manage-account/manage-account.component';
import { CanAuthenticationGuard } from '../providers/auth-guard';

/**
  * @ngdoc overview
  * @name MODULE_NAME.module:AccountsModule
  *
  * @description
  * description: To route to different components in accounts module based on the path given
*/
const routes: Routes = [
  {
    path: 'accounts/create-accounts',
    component: CreateAccountComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'ACC_C', data: {} }
  },
  {
    path: 'accounts/manage-accounts',
    component: ManageAccountComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'ACC_R', data: {} }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountsRoutingModule { }
